import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './common.module.css';
import homeImage from './assets/bannerIllustration.svg';

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className={styles.pageWrapper}>
      <header className={styles.header}>
        <nav className={styles.nav}>
          {/* <button onClick={() => navigate('/about')}>About</button>
          <button onClick={() => navigate('/contact')}>Contact</button> */}
          <button onClick={() => navigate('/login-signup')}>Login/Signup</button>
        </nav>
      </header>

      <main className={styles.imageContainer}>
        <img src={homeImage} alt="Home Visual" className={styles.homeImage} />
        <div className={styles.overlayContent}>
          <div className={styles.textWrapper}>
            <h2 className={styles.heroHeading}>
              /Defining <span className={styles.violet}>API’s:</span>
              <br />
              Simplify <span className={styles.blue}>OpenAPI</span> specification.
            </h2>
            <p className={styles.heroSubtext}>
              Say goodbye to text editors.
              Build and manage OpenAPI specifications without the hassle.
              With SpecWizard, create clean, accurate API docs — fast, simple, and developer-friendly.
            </p>
            <div className={styles.homeButtonGroup}>
              <button className={styles.startButton} onClick={() => navigate('/login-signup')}>Get Started</button>
            </div>
          </div>
        </div>
      </main>

      <footer className={styles.footer}>
        <nav className={styles.footerNav}>
          {/* <button onClick={() => navigate('/privacy')}>Privacy Policy</button>
          <button onClick={() => navigate('/terms')}>Terms & Conditions</button> */}
        </nav>
        <p style={{ color: 'White' }}>&copy; {new Date().getFullYear()} Specwizard AI LLC. All rights reserved.</p>
      </footer>
    </div>
  );
}
